import { Component, OnInit, ChangeDetectorRef, EventEmitter, Output, OnDestroy} from '@angular/core';
import { Chart } from 'chart.js';
import { AnalysisService } from '../../shared/services/graphics/analysis.service';
import { VqtPoint, AudioDelayPoint, FaxBar } from '../../shared/models/graphics/analysis';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { rsltTypeInTitle, rsltTypeInAPICall } from 'src/app/shared/functions/title';
//import { DataManager, CdtSettings, Column } from 'lib/ng-crud-table';
//import { getColumnsHeaders } from 'src/app/shared/columns';
import { DemoService } from 'src/app/shared/demo.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { BasicComponent } from 'src/app/shared/basic/basic.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.scss',
    '../../../../lib/dt-toolbar/dt-toolbar.component.css',
    '../../../../lib/styles/icons.css',
    '../../../../lib/styles/context-menu.css',
    '../../../../lib/styles/list-menu.css'],
  providers: [AnalysisService]
})
export class AnalysisComponent implements OnInit, OnDestroy {
  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  isFilters: boolean = true;
  hasFilters: boolean;

  rsltType: string = "analysis";

  rsltTypeTS = '-1';
  TSSelected: number;

  AutoRefreshInfo: any;

  title: string = "Analysis Graphics";
  staticScreen = false;
  @Output() childTitleEvent = new EventEmitter();

  isLoading = true;

  interval;

  private subscriptions: Subscription[] = [];
  filterEventIDSelected = false;
  delColSelected = false;
  columnName = "VQuad_Timestamp";
  TimestampType = 1;
  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private analysisService: AnalysisService, private service: DemoService, private commonFilterService: CommonFilterService,
    private dialog: MatDialog, private cdr: ChangeDetectorRef) {
    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;

      this.parentEvent();
    });
    this.commonFilterService.setNonFiltersScreen(this.staticScreen);

    this.commonFilterService.TSType.subscribe(res => {//TsType
      this.TimestampType = res;
      if (this.TimestampType >= 2)//
        this.TimestampType = 1;//Change VQT to VQuad Timestamp if screen doesn't belongs to VQT types nd send as TSTYpe in filtering - IMP
      this.columnName = "VQuad_Timestamp";
      if (this.TimestampType == 2) {
        this.columnName = "VQT_Timestamp";
      }
      else if (this.TimestampType == 0) {
        this.columnName = "Call_Timestamp";
      }
    });

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      //console.log('listen')
      if (res === 'onlyAnalGrphInit' && !this.filterEventIDSelected)
        this.createAllBarGraphs('');
      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.createAllBarGraphs('');
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        if (res !== '') {//IMP IMP
          this.createAllBarGraphs(res);
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('AllGeneralFilter')
        this.AllGeneralFilter = res;
        if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
          this.createAllBarGraphs('');

        //reset here
        if (this.delColSelected)
          this.delColSelected = false;
        if (this.clearAllFiltersBool)
          this.clearAllFiltersBool = false;
      }
    );
    this.subscriptions.push(_broadSubAllGeneralFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('filtersWithEventID')
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0))
        //  this.createAllBarGraphs('');
      }
    );
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(this.AutoRefreshInfo);

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            this.createAllBarGraphs('');
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);

  }
  parentEvent() {
    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
  }
  ngOnInit() {
    //this.hasFilters = this.table.dataFilter.hasFilters();
    if (this.lineGraph1 != null)
      this.lineGraph1.destroy();
    if (this.lineGraph2 != null)
      this.lineGraph2.destroy();
    if (this.barGraph3 != null)
      this.barGraph3.destroy();
    //this.createAllBarGraphs();

    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
    //this.setRsltType();
  }
  parentEventID() {
    this.createAllBarGraphs('');
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  clearAllFiltersBool = false;
  clearAllFilters() {
    
    this.createAllBarGraphs('clearAllFilters');
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }

  //https://stackoverflow.com/questions/56715475/add-ng2-charts-to-angular-7-application

  //https://www.js-tutorials.com/angularjs-tutorial/angular-6-chart-tutorial-using-chart-js/
  //https://dev.to/wiaio/implementing-a-chartjs-line-chart-in-your-angular-application-19d7
  //https://www.c-sharpcorner.com/article/create-charts-in-angular-7-application-using-chart-js2/
  lineGraph1 = null;
  lineGraph2 = null;
  barGraph3 = null;
  AllGeneralFilter = [];
  genArrDel = [];
  filtersWithEventID = {};
  filters = {};
  vqtPoint: VqtPoint[]= [];
  audioDelayPoint: AudioDelayPoint[] = [];
  //@ViewChild('modalCrudToggler', { static: false }) modalCrudToggler: CrudTableComponent;
  createAllBarGraphs(delFilterColName) {
    debugger;
    if (delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key !== this.columnName)
          delete this.filters[key];
      }
    }
    this.isLoading = true;

    this.vqtPoint = [];
    let vqtHead = "VQT RESULTS";
    this.audioDelayPoint = [];
    let audioDelayHead = "AUDIO DELAY ANALYSIS";

    let faxBar: FaxBar[];
    let faxHead = "FAX EVENTS";
    this.analysisService.getAnalysisList(delFilterColName, this.AllGeneralFilter, this.filtersWithEventID, this.filters, this.TimestampType, this.columnName).then(responseList => {
      //https://stackoverflow.com/a/30468773
      //https://stackoverflow.com/questions/40056555/destroy-chart-js-bar-graph-to-redraw-other-graph-in-same-canvas
      //https://stackoverflow.com/questions/24785713/chart-js-load-totally-new-data
      if (this.lineGraph1 != null)
        this.lineGraph1.destroy();
      if (this.lineGraph2 != null)
        this.lineGraph2.destroy();
      if (this.barGraph3 != null)
        this.barGraph3.destroy();
     // this.cdr.detectChanges();

      let dateUnit = responseList[0][1];
      for (var y = 1; y < 3; y++) {
        if (y == 1) {
          this.vqtPoint = <VqtPoint[]>responseList[y];
          //console.log(this.vqtPoint)
          if (this.vqtPoint[0].VQuadNewTS != undefined) {
            if (this.vqtPoint[0].VQuadNewTS.trim().length != 0) {
              //https://stackoverflow.com/a/73949568
              //let tsNew = this.vqtPoint.map(s => ({ x: new Date(s.VQuadNewTSOrig), y: s.POLQA_Score }));
              //console.log(this.vqtPoint[0].VQuadNewTS.trim())

              //let dateFormatChk = this.vqtPoint[0].VQuadNewTS.trim().split(' ');
              //let dateFormat = "MM/DD/YYYY HH:mm:ss";//default
              
              //if (dateFormatChk.length == 1) {//month or year or days

              //  if (dateFormatChk[0].split('/').length == 3) {
              //    dateFormat = "MM/DD/YYYY";
              //    dateUnit = 'day';
              //  }
              //  else if (dateFormatChk[0].split('/').length == 2) {
              //    dateFormat = "MM/YYYY";
              //    dateUnit = 'month';
              //  }
              //  else {
              //    dateFormat = "YYYY";
              //    dateUnit = 'year';
              //  }
              //}
              //else if (dateFormatChk.length == 2) {
              //  if (dateFormatChk[1].split(':').length == 2) {
              //    dateFormat = "MM/DD/YYYY HH:mm";
              //    dateUnit = 'minute';
              //  }
              //  else {
              //    dateFormat = "MM/DD/YYYY HH";
              //    dateUnit = 'hour';
              //  }
              //}
              //console.log(dateUnit)
              let pesqData = this.vqtPoint.map(x => x.PESQ_Score).filter(x => x != 0);
              let pesqLqData = this.vqtPoint.map(x => x.PESQ_LQ).filter(x => x != 0);
              let pesqLqoData = this.vqtPoint.map(x => x.PESQ_MOS).filter(x => x != 0);
              let pesqWbData = this.vqtPoint.map(x => x.PESQ_WB).filter(x => x != 0);
              let polqaScoreData = this.vqtPoint.map(x => x.POLQA_Score).filter(x => x != 0);
              let polqaV3Data = this.vqtPoint.map(x => x.POLQA_v3).filter(x => x != 0);
              //http://tobiasahlin.com/blog/chartjs-charts-to-get-you-started/
              //https://www.chartjs.org/docs/latest/charts/scatter.html#scatter-chart

              ////https://stackoverflow.com/questions/54536014/is-it-possible-to-merge-duplicate-labels-and-their-datas-into-one-column-in-ch
              ////https://stackoverflow.com/questions/68282921/how-to-group-duplicate-labels-in-order-to-create-a-label-without-duplicates-in-c
              //const dataReduced = this.vqtPoint.reduce(
              //  (a, b) => {
              //    const i = a.months.findIndex(x => x === b.VQuadNewTS);

              //    if (i === -1) {
              //      a.months.push(b.VQuadNewTS);
              //    }
              //    else {
              //      a.months.push("");
              //    }
              //    a.products.push(b.POLQA_Score);

              //    return a;
              //  },
              //  { months: [], products: [] }
              //);

              //console.log(dataReduced.months);
              //console.log(dataReduced.products);

              //https://stackoverflow.com/questions/41280857/chart-js-failed-to-create-chart-cant-acquire-context-from-the-given-item
              //https://stackoverflow.com/questions/58218597/property-getcontext-does-not-exist-on-type-htmlelement
              this.lineGraph1 = new Chart((<HTMLCanvasElement>document.getElementById("line-chart" + y)).getContext("2d"), {
                type: 'line',
                data: {
                  labels: this.vqtPoint.map(x => new Date(x.VQuadNewTSOrig)),//dataReduced.months,
                  datasets: [{
                    data: pesqData,
                    label: "PESQ",
                    borderColor: "#3e95cd",
                    fill: false,
                    showLine: false//https://www.chartjs.org/docs/latest/charts/line.html
                  }, {
                    data: pesqLqData,
                    label: "PESQ LQ",
                    borderColor: "#8e5ea2",
                    fill: false,
                    showLine: false
                  }, {
                    data: pesqLqoData,
                    label: "PESQ LQO",
                    borderColor: "#3cba9f",
                    fill: false,
                    showLine: false
                  }, {
                    data: pesqWbData,
                    label: "PESQ WB",
                    borderColor: "#e8c3b9",
                    fill: false,
                    showLine: false
                    }, {
                      data: polqaScoreData,//dataReduced.products,
                      label: "POLQA MOS",
                      borderColor: "#c45850",
                      fill: false,
                      showLine: false
                    }, {
                    data: polqaV3Data,
                    label: "POLQA v3",
                    borderColor: "rgba(255,221,50,1)",
                    fill: false,
                    showLine: false
                  }
                  ]
                },
                options: {
                  ////https://stackoverflow.com/questions/44826806/angular-chart-js-onclick-is-not-working-how-to-get-all-elements-of-a-bar-when
                  //onClick: function (e) {
                  //  var element = this.getElementAtEvent(e);
                  //  if (element.length) {
                  //    console.log(element);
                  //    this.setRsltType('polqa', this.vqtPoint[element[0]._index].ID);

                  //    this.OpenBasicDialog(this.vqtPoint[element[0]._index].ID);
                  //  }
                  //},
                  responsive: true,
                  ////https://stackoverflow.com/a/42356473
                  //events: ["click"],
                  ////https://codepen.io/k3no/pen/OReEKx?editors=0010
                  ////https://www.chartjs.org/docs/latest/samples/tooltip/html.html
                  ////https://jsfiddle.net/Lx6ahtb9/
                  //tooltips: {
                  //  enabled: false,

                  //  tooltipTitleFontSize: 0,
                  //  titleFontSize: 0,
                  //  titleFontColor: 'black',
                  //  title: false,

                  //  backgroundColor: 'rgba(255,255,255,0)',
                  //  displayColors: false,
                  //  //callbacks: {
                  //  //  label: function (tooltipItems, data) {
                  //  //    return tooltipItems.yLabel + '%';
                  //  //  }
                  //  //},
                  //  borderWidth: 2,
                  //  borderColor: 'black',

                  //  bodyFontSize: 20,
                  //  bodyFontFamily: 'Helvetica Neue',
                  //  bodyFontColor: 'black',

                  //  titleMarginBottom: 0,
                  //  custom: function (tooltipModel) {

                  //    // Tooltip Element
                  //    var tooltipEl = document.getElementById('chartjs-tooltip');

                  //    // Create element on first render
                  //    if (!tooltipEl) {
                  //      tooltipEl = document.createElement('div');
                  //      tooltipEl.id = 'chartjs-tooltip';
                  //      tooltipEl.innerHTML = "<table></table>";
                  //      document.body.appendChild(tooltipEl);
                  //    }

                  //    // Hide if no tooltip
                  //    if (tooltipModel.opacity === 0) {
                  //      tooltipEl.style.opacity = '1';
                  //      return;
                  //    }

                  //    tooltipModel.opacity = 1;

                  //    // Set caret Position
                  //    tooltipEl.classList.remove('above', 'below', 'no-transform');
                  //    if (tooltipModel.yAlign) {
                  //      tooltipEl.classList.add(tooltipModel.yAlign);
                  //    } else {
                  //      tooltipEl.classList.add('no-transform');
                  //    }

                  //    function getBody(bodyItem) {
                  //      return bodyItem.lines;
                  //    }

                  //    // Set Text
                  //    if (tooltipModel.body) {
                  //      var titleLines = tooltipModel.title || [];
                  //      var bodyLines = tooltipModel.body.map(getBody);

                  //      var innerHtml = '<div>';

                  //      titleLines.forEach(function (title) {
                  //        //innerHtml += '<span>' + title + '</span>';
                  //      });
                  //      innerHtml += '</div>';
                  //      bodyLines.forEach(function (body, i) {
                  //        var colors = tooltipModel.labelColors[i];
                  //        var style = 'background:' + colors.backgroundColor;
                  //        style += '; border-color:' + colors.borderColor;
                  //        style += '; border-width: 2px';
                  //        var span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>';
                  //        innerHtml += '<div class="inner">' + span + body + '</div>';
                  //      });
                  //      innerHtml += '<hr>';

                  //      var tableRoot = tooltipEl;
                  //      tableRoot.innerHTML = innerHtml;
                  //    }

                  //    // `this` will be the overall tooltip
                  //    var position = this._chart.canvas.getBoundingClientRect();

                  //    // Display, position, and set styles for font
                  //    tooltipEl.style.opacity = '1';
                  //    tooltipEl.style.left = position.left + tooltipModel.caretX + 'px';

                  //    tooltipEl.style.top = position.top + tooltipModel.caretY + 'px';
                  //    tooltipEl.style.fontFamily = tooltipModel._fontFamily;
                  //    tooltipEl.style.fontSize = tooltipModel.fontSize;
                  //    tooltipEl.style.fontStyle = tooltipModel._fontStyle;
                  //    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';


                  //  }
                  //  //bodyFontSize: 20
                  //},
                  tooltips: {
                    enabled: true,
                    //callbacks: {
                    //  //https://stackoverflow.com/questions/42294179/remove-the-label-and-show-only-value-in-tooltips-of-a-bar-chart
                    //  title: function (tooltipItems, data) {
                    //    return '';
                    //  },
                    //  label: function (tooltipItems, data) {
                    //    //console.log(tooltipItems)
                    //    //console.log(data)
                    //    return 'Click to view details';
                    //  }
                    //},

                    //custom: function (tooltipModel) {
                    //  console.log(tooltipModel)
                    //  var bodyLines = tooltipModel.body.map(getBody);
                    //},
                  },
                  title: {
                    display: true,
                    text: vqtHead
                  },
                  scales: {
                    //https://stackoverflow.com/questions/65450854/adjusting-x-axis-labels-for-dates-chartjs
                    xAxes: [{
                      ////https://stackoverflow.com/questions/68702009/how-to-set-the-xaxes-min-and-max-values-of-time-cartesian-chart-in-chart-js
                      //min: new Date(responseList[0][2]),
                      //max: new Date(responseList[0][3]),
                      type: 'time',
                      //display: true,
                      //scaleLabel: {
                      //  display: true,
                      //  labelString: 'Date'
                      //},
                      time: {
                        //https://stackoverflow.com/questions/39535155/chart-js-timescale-set-min-and-max-on-xaxes
                        min: new Date(responseList[0][2]),
                        max: new Date(responseList[0][3]),
                        //parser: 'YYYY-MM-DD HH:mm:ss',
                        unit: dateUnit,//https://www.chartjs.org/docs/latest/axes/cartesian/time.html#time-units
                        //autoSkip: true,
                        tooltipFormat: "MM/DD/YYYY HH:mm:ss",//https://stackoverflow.com/questions/61474243/change-date-format-in-tooltip-of-chart-js
                        displayFormats: {
                          second: "MM/DD/YYYY HH:mm:ss",
                          minute: "MM/DD/YYYY HH:mm", 
                          hour: "MM/DD/YYYY HH:00",
                          day: "MM/DD/YYYY",
                          month: "MM/YYYY",
                          year: "YYYY"
                        }
                      },
                      ticks: {
                        ////major: {
                        ////  fontStyle: 'bold',
                        ////  fontColor: '#FF0000'
                        ////}

                        //https://stackoverflow.com/questions/35022830/chart-js-change-label-orientation-on-x-axis-for-line-charts
                        //autoSkip: false,
                        maxRotation: 45,
                        minRotation: 45,
                        ////https://stackoverflow.com/questions/22064577/limit-labels-number-on-chart-js-line-chart
                        //maxTicksLimit: 15
                      }
                    }],

                    yAxes: [{
                      ticks: {
                        beginAtZero: true,
                        //https://stackoverflow.com/questions/68992642/setting-up-min-and-max-in-chartjs-did-not-work
                        //min: 0,
                        //stepSize: 20
                      }
                    }]
                  },
                  //https://codepen.io/anon/pen/PGabEK
                  //https://github.com/valor-software/ng2-charts/issues/837
                  //https://github.com/chartjs/chartjs-plugin-zoom/blob/1cf272f43cef1545f63c927c15e54fcc41673177/samples/pan-bar.html
                  // Container for pan options 
                  pan: {
                    // Boolean to enable panning
                    enabled: false,

                    // Panning directions. Remove the appropriate direction to disable 
                    // Eg. 'y' would only allow panning in the y direction
                    mode: 'xy'
                  },

                  // Container for zoom options
                  zoom: {
                    // Boolean to enable zooming
                    enabled: false,

                    // Zooming directions. Remove the appropriate direction to disable 
                    // Eg. 'y' would only allow zooming in the y direction
                    mode: 'xy',
                  }
                }
              });
            }
          }
        }
        else {
          this.audioDelayPoint = <AudioDelayPoint[]>responseList[y];
          if (this.audioDelayPoint[0].VQuadNewTS != undefined) {
            if (this.audioDelayPoint[0].VQuadNewTS.trim().length != 0) {
              let rtdData = this.audioDelayPoint.map(x => x.RTD);
              let owdData = this.audioDelayPoint.map(x => x.OWD);
              let pddData = this.audioDelayPoint.map(x => x.PDD);
              let snrData = this.audioDelayPoint.map(x => x.SNR);
              this.lineGraph2 = new Chart((<HTMLCanvasElement>document.getElementById("line-chart" + y)).getContext("2d"), {
                type: 'line',
                data: {
                  labels: this.audioDelayPoint.map(x => new Date(x.VQuadNewTSOrig)),
                  datasets: [{
                    data: rtdData,
                    label: "RTD",
                    borderColor: "#3e95cd",
                    fill: false,
                    showLine: false
                  }, {
                    data: owdData,
                    label: "OWD",
                    borderColor: "#8e5ea2",
                    fill: false,
                    showLine: false
                  }, {
                    data: pddData,
                    label: "PDD",
                    borderColor: "#3cba9f",
                    fill: false,
                    showLine: false
                  }, {
                    data: snrData,
                    label: "SNR",
                    borderColor: "#e8c3b9",
                    fill: false,
                    showLine: false
                  }
                  ]
                },
                options: {
                  responsive: true,
                  tooltips: {
                    enabled: true,
                    //callbacks: {
                    //  title: function (tooltipItems, data) {
                    //    return '';
                    //  },
                    //  label: function (tooltipItems, data) {
                    //    return 'Click to view details';
                    //  }
                    //},
                  },
                  title: {
                    display: true,
                    text: audioDelayHead
                  },
                  scales: {
                    xAxes: [{
                      type: 'time',
                      //display: true,
                      //scaleLabel: {
                      //  display: true,
                      //  labelString: 'Date'
                      //},
                      time: {
                        min: new Date(responseList[0][2]),
                        max: new Date(responseList[0][3]),
                        //parser: 'YYYY-MM-DD HH:mm:ss',
                        unit: dateUnit,//https://www.chartjs.org/docs/latest/axes/cartesian/time.html#time-units
                        //autoSkip: true,
                        tooltipFormat: "MM/DD/YYYY HH:mm:ss",//https://stackoverflow.com/questions/61474243/change-date-format-in-tooltip-of-chart-js
                        displayFormats: {
                          second: "MM/DD/YYYY HH:mm:ss",
                          minute: "MM/DD/YYYY HH:mm",
                          hour: "MM/DD/YYYY HH:00",
                          day: "MM/DD/YYYY",
                          month: "MM/YYYY",
                          year: "YYYY"
                        }
                      },
                      ticks: {
                        ////major: {
                        ////  fontStyle: 'bold',
                        ////  fontColor: '#FF0000'
                        ////}
                        //autoSkip: false,
                        maxRotation: 45,
                        minRotation: 45
                      }
                    }],
                    yAxes: [{
                      ticks: {
                        beginAtZero: true
                      }
                    }]
                  },
                  // Container for pan options
                  pan: {
                    // Boolean to enable panning
                    enabled: false,

                    // Panning directions. Remove the appropriate direction to disable 
                    // Eg. 'y' would only allow panning in the y direction
                    mode: 'xy'
                  },

                  // Container for zoom options
                  zoom: {
                    // Boolean to enable zooming
                    enabled: false,

                    // Zooming directions. Remove the appropriate direction to disable 
                    // Eg. 'y' would only allow zooming in the y direction
                    mode: 'xy',
                  }
                }
              });
            }
          }
        }
      }
     
      for (var x = 3; x < 4; x++) {
        faxBar = <FaxBar[]>responseList[x];
        if (faxBar[0].VQuadNewTS != undefined) {
          if (faxBar[0].VQuadNewTS.trim().length != 0) {
            //this.barGraph3 = new Chart('dash-bar-graph' + x, {
            this.barGraph3 = new Chart('dash-bar-graph31', {
              type: 'bar',
              data: {
                labels: faxBar.map(x => x.VQuadNewTS),
                datasets: [
                  {
                    backgroundColor: 'darkgreen',  //'rgba(92, 107, 192, .7)',
                    borderColor: 'darkgreen',  //'rgba(92, 107, 192, .7)',
                    data: faxBar.map(x => x.SENDFAXPASSED),
                    label: 'SEND SUCCESS',
                    fill: 'false'
                  },
                  {
                    backgroundColor: 'red',  //'rgba(66, 165, 245, .7)',
                    borderColor: 'red',  //'rgba(69, 39, 160, .7)',
                    data: faxBar.map(x => x.SENDFAXFAILED),
                    label: 'SEND FAILURE',
                    fill: 'false'
                  },
                  {
                    backgroundColor:'blue', //'rgba(38, 166, 154, .7)',
                    borderColor: 'blue', //'rgba(69, 39, 160, .7)',
                    data: faxBar.map(x => x.RECEFAXPASSED),
                    label: 'RECEIVE SUCCESS',
                    fill: 'false'
                  },
                  {
                    backgroundColor:'black',// 'rgba(102, 187, 106, .7)',
                    borderColor: 'black',//'rgba(255, 99, 132)',
                    data: faxBar.map(x => x.RECEFAXFAILED),
                    label: 'RECEIVE FAILURE',
                    fill: 'false'
                  }
                ]
              },
              options: {
                responsive: true,
                legend: {
                  display: true
                },
                elements: {
                  line: {
                    tension: 0.000001
                  }
                },
                maintainAspectRatio: false,
                plugins: {
                  filler: {
                    propagate: false
                  }
                },
                title: {
                  display: true,
                  text: faxHead
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                    }
                  }]
                }
              }
            });
            //this.barGraph3.render();
            //this.cdr.detectChanges();
          }
        }
      }

      this.hasFilters = responseList[4] <= 0 ? false : true;
    }).catch(error => {
        this.isLoading = false;
      }
    ).finally(() => {
      this.isLoading = false;
      });
    //https://lucymarmitchell.medium.com/using-then-catch-finally-to-handle-errors-in-javascript-promises-6de92bce3afc

    if (delFilterColName != '' && delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != delFilterColName;
      });
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (delFilterColName == 'clearAllFilters') {
      debugger;
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);
      this.commonFilterService.setGeneralFilterDFData(this.filters);//mainly used in main screen

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    //this.cdr.detectChanges();
  }

  //columns: Column[];
  //dataManager: DataManager;
  //settings: CdtSettings = new CdtSettings({
  //  crud: false,//create button toggle used to create dynamic row from columns set - IMP
  //  //bodyHeight: 380,
  //  exportAction: false,
  //  globalFilter: false,
  //  clickRows: true,
  //  columnToggleAction: false,
  //  clearAllFiltersAction: false,
  //  unshiftExpandIcon: false,//Toggle frst dynamic column haing icon to show details view, update, etc as menu items - IMP
  //});

  //setRsltType(rsltType, requestID) {

  //  //https://stackoverflow.com/questions/208105/how-do-i-remove-a-property-from-a-javascript-object - Not needed
  //  //https://love2dev.com/blog/javascript-remove-from-array/ - Not Needed
  //  //https://www.freecodecamp.org/news/manipulating-arrays-in-javascript/ - Not Needed
  //  let TSTypesHidden = "";

  //  switch (rsltType) {
  //    case "pesq":
  //      this.rsltTypeTS = '-1';
  //      if (this.TSSelected == 2)//for vqt TS selection in common filter
  //        TSTypesHidden = "VQuad_Timestamp";
  //      else//for either call or vquad TS selection in common filter
  //        TSTypesHidden = "VQT_TimeStamp";
  //      break;
  //    case "polqa":
  //      this.rsltTypeTS = '-1';
  //      if (this.TSSelected == 2)//for vqt TS selection in common filter
  //        TSTypesHidden = "VQuad_Timestamp";
  //      else//for either call or vquad TS selection in common filter
  //        TSTypesHidden = "VQT_Timestamp";
  //      break;
  //    default:
  //      this.rsltTypeTS = '2';
  //      break;
  //  }
  //  let selectedSubResults = null;
  //  this.columns = getColumnsHeaders(rsltType, selectedSubResults);


  //  //For Call Timestamp grouping, remove column from main table and show it in each header with count - IMP
  //  //For other TS Selection can also be used to hide the other TS column
  //  if (TSTypesHidden !== "")
  //    this.columns.find(x => x.name === TSTypesHidden).tableHidden = true;

  //  if (this.TSSelected == 0)//for call TS selection in common filter
  //  {
  //    this.columns.find(x => x.name === 'Call_Timestamp').tableHidden = true;
  //    //For Call Timestamp grouping Enabling dynamically - VERY IMP
  //    //https://github.com/mazdik/ng-mazdik/blob/master/src/app/demo/row-group-demo.component.ts
  //    this.settings.groupRowsBy = ['Call_Timestamp'];
  //    this.settings.groupRowsByTitles = ['Call Timestamp'];
  //    this.settings.rowHeightProp = '$$height';
  //  }
  //  else {//reset to vquad/vqt timestamp filter
  //    this.columns.find(x => x.name === 'Call_Timestamp').tableHidden = false;
  //    //For Call Timestamp grouping Enabling dynamically - VERY IMP
  //    //https://github.com/mazdik/ng-mazdik/blob/master/src/app/demo/row-group-demo.component.ts
  //    this.settings.groupRowsBy = [];
  //    this.settings.groupRowsByTitles = [];
  //    this.settings.rowHeightProp = '';

  //  }
  //  //console.log(this.columns)

  //  //this.columns.forEach((x, i) => (i > 0) ? x.editable = true : x.editable = false);//IMP-edit each cell

  //  //this.columns[4].filterValues = this.filterValuesFunc;
  //  this.dataManager = new DataManager(this.columns, this.settings, this.service, null, rsltTypeInAPICall(rsltType), rsltType,
  //    '', 0, requestID);
  //  this.dataManager.pager.perPage = 20;
  //  //console.log(this.dataManager)
  //}



  //successMsgBasic: boolean = false;
  OpenBasicDialog(requestID, rsltType) {

    const dailogConfig = new MatDialogConfig();
    //dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    //dailogConfig.width = "40%";
    dailogConfig.data = { popupOrNot: true, requestID: requestID, rsltType: rsltType, TSSelected: this.TSSelected };

    this.dialog.open(BasicComponent, dailogConfig);

    //dialogRef.afterClosed().subscribe(
    //  data => { this.successMsgBasic = data; }
    //);
  }

  //https://stackoverflow.com/questions/50607215/angular-5-chart-js-onclick-returning-empty-array
  showVQTData(evt: any) {
    if (this.lineGraph1 == null)
      return false;
    var data = this.lineGraph1.getElementsAtEvent(evt);
    //console.log(data)
    if (data.length == 0)
      return false;

    //https://jsfiddle.net/w6oxwwte/
    var dsindex = this.lineGraph1.getDatasetAtEvent(evt)[0]._datasetIndex;
    let rsltType = 'pesq';
    //console.log(this.vqtPoint[data[0]._index].ID)
    //console.log(this.lineGraph1.data.datasets[dsindex].data)
    //https://github.com/chartjs/Chart.js/issues/2953#issuecomment-510167034
    if (this.lineGraph1.data.datasets[dsindex].label.indexOf('POLQA') != -1)
      rsltType = 'polqa';
    //this.OpenBasicDialog(this.vqtPoint[data[0]._index + 1].ID, rsltType);
    this.OpenBasicDialog(this.vqtPoint[data[0]._index].ID, rsltType);
  }

  showADMData(evt: any) {
    if (this.lineGraph2 == null)
      return false;
    var data = this.lineGraph2.getElementsAtEvent(evt);
    if (data.length == 0)
      return false;
    //console.log(this.audioDelayPoint[data[0]._index])
    //var dsindex = this.lineGraph2.getDatasetAtEvent(evt)[0]._datasetIndex;
    //console.log(this.lineGraph2.data.datasets[dsindex])
    let rsltType = 'audio-delay';
    this.OpenBasicDialog(this.audioDelayPoint[data[0]._index].ID, rsltType);
  }
}
